import React from 'react';
import withIcon from '../utilities/withIcon';

const IconShare = () => {
  return (
    <g>
      <path d="m15.791 5.314a.7266.7266 0 0 0 .0519-.077.7066.7066 0 0 0 0-.6249.7223.7223 0 0 0 -.0525-.0779.7358.7358 0 0 0 -.1411-.1715c-.0112-.01-.0157-.0245-.0275-.0335l-4.2812-3.2807a.75.75 0 1 0 -.9121 1.19l2.5257 1.9356h-3.3412c-3.8208 0-6.93 2.3926-6.93 5.3335a.75.75 0 1 0 1.5 0c0-2.1138 2.4356-3.8335 5.43-3.8335h3.3413l-2.5259 1.936a.75.75 0 1 0 .9121 1.19l4.2813-3.2801c.0118-.009.0163-.0238.0275-.0335a.7364.7364 0 0 0 .1417-.1725z" />
      <path d="m12.2869 9.6066a.75.75 0 0 0 -.75.75v3.25h-9.9527v-9.9526h4.9912a.75.75 0 0 0 0-1.5h-5.7412a.75.75 0 0 0 -.75.75v11.4526a.75.75 0 0 0 .75.75h11.4527a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 0 -.75-.75z" />
    </g>
  );
};

export default withIcon(IconShare);
